// A public URL channel visitor signing in as themselves from the app header.
//
// The credentials are collected in the header popover but the sign-in itself
// runs on /a/signin (ChannelSignIn), because ending the channel session inside
// the patient app trips its route guard and throws the visitor onto the login
// page while the request is still in flight.
//
// Module memory, deliberately: the password must not reach the history entry
// (history.push state is written to window.history) or any storage. One-shot —
// the hand-over reads it once and it is gone, so a reload of /a/signin has
// nothing to replay.
let pending = null;

export const CHANNEL_SIGN_IN_PATH = "/a/signin";

export const stashChannelSignIn = (username, password) => {
  pending = { username, password };
};

export const takeChannelSignIn = () => {
  const credentials = pending;
  pending = null;
  return credentials;
};
